/**
 * @file _form-join.js
 */
'use strict';
import Common from '../../util/_common';

/**
 * @classname FormJoin
 * @classdesc 会員登録フォーム
 */
export default class FormJoin {
	/**
	 * @constructor
	 * @param {object} controller - コントローラー
	 */
	constructor(controller){
		this._controller = controller;
	};


	/**
	 * フォーム送信前処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	preProcessing($form) {
		console.log('FormJoin.preProcessing');
		// バリデーション前に行う処理を記載（開始）
	};


	/**
	 * フォーム送信後処理
	 *
	 * @memberof Sample
	 * @return {undefined}
	 */
	postProcessing($form) {
		console.log('FormJoin.postProcessing');
		// バリデーション後に行う処理を記載（開始）

		// 名前の統合
		$('.user_name').val(`${$('.user_name1').val()} ${$('.user_name2').val()}`);
		// 名前カナの統合
		$('.user_name_kana').val(`${$('.user_name_kana1').val()} ${$('.user_name_kana2').val()}`);


		// バリデーション後に行う処理を記載（終了）
		this._controller.completePostProcessing($form);
	};
}
